import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CarrinhoService } from 'src/app/service/carrinho.service';
import { StorageService } from 'src/app/service/shared/storage.service';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';


const FORMAS_ENTREGA: any = [
  {
    id_forma: 1,
    descricao: 'Na Escola',
  },
  {
    id_forma: 2,
    descricao: 'Sedex',
  },
  {
    id_forma: 3,
    descricao: 'PAC',
  },
  {
    id_forma: 4,
    descricao: 'Entrega Local',
  }
]
@Component({
  selector: 'app-forma-entrega',
  templateUrl: './forma-entrega.component.html',
  styleUrls: ['./forma-entrega.component.scss']
})
export class FormaEntregaComponent {
  public readonly aba: string = 'formaEntrega';

  public nome_escola!: string;

  public dependentes: any[] = [];
  public total: number = 0;

  public forma_entrega = FORMAS_ENTREGA;

  public dadosEscola = JSON.parse(this.storage.getEscola());

  public formaSelecionada!: number;

  public endereco = `${this.dadosEscola.endereco}, ${this.dadosEscola.numero} - ${this.dadosEscola.bairro} - ${this.dadosEscola.cidade} - ${this.dadosEscola.estado} CEP: ${this.dadosEscola.cep}`

  public isLoading: boolean = true;

  public displayedColumns: string[] = [
    'nome_dependente',
    'valor',
  ];
  public dataSource!: MatTableDataSource<any>;

  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private router: Router,
    private storage: StorageService,
    private carrinho: CarrinhoService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    if (this.storage.isloggedIn()) {
      this.nome_escola = JSON.parse(this.storage.getEscola()).nome_escola;
      this.carregaResumoDependentes()
      this.somaValorTotal();
    } else {
      this.router.navigate(['/'])
    }
  }

  private carregaResumoDependentes() {
    this.carrinho.resumoCarrinho(this.storage.getGUID()).subscribe((dependentes) => {
      this.dependentes = dependentes;
      this.dataSource = new MatTableDataSource<any>(this.dependentes);
      this.dataSource.sort = this.sort;
      this.isLoading = false;
      this.somaValorTotal();
    });
  }

  private somaValorTotal() {
    this.total = 0;
    this.dependentes.forEach(item => {
      this.total += parseFloat(item.total);
    })
  }

  private salvaFormaSelecionadaSessao() {
    this.storage.saveFormaSelecionada(this.formaSelecionada);
  }

  public continuar() {
    if (this.formaSelecionada == null || this.formaSelecionada == 0 || this.formaSelecionada == undefined) {
      this.dialog.open(DialogComponent, { data: 'Você precisa selecionar uma forma de entrega.' })
    } else {
      this.salvaFormaSelecionadaSessao();
      this.router.navigate(['/endereco-entrega']);
    }
  }
}
